export default __webpack_public_path__ + "yellow_curve.038cf8.svg";